import { TypographyOptions } from '@mui/material/styles/createTypography';

// Update the Typography's options
declare module '@mui/material/styles' {
  interface TypographyVariants {
    subheadline: React.CSSProperties;
    footnote: React.CSSProperties;
    navigation: React.CSSProperties;
    title1: React.CSSProperties;
    title2: React.CSSProperties;
    title3: React.CSSProperties;
    callout: React.CSSProperties;
    extraLargeNumber: React.CSSProperties;
    headline: React.CSSProperties;
    label: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    subheadline?: React.CSSProperties;
    footnote?: React.CSSProperties;
    navigation?: React.CSSProperties;
    title1?: React.CSSProperties;
    title2?: React.CSSProperties;
    title3?: React.CSSProperties;
    callout?: React.CSSProperties;
    extraLargeNumber?: React.CSSProperties;
    headline?: React.CSSProperties;
    label?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    subheadline: true;
    headline: true;
    footnote: true;
    navigation: true;
    title1: true;
    title2: true;
    title3: true;
    callout: true;
    extraLargeNumber: true;
    label: true;
  }
}

// For non-default typography variants, fontFamily needs to be explicitly specified
// https://github.com/mui/material-ui/issues/35939
export const typography: TypographyOptions = {
  h6: {
    fontWeight: 500,
    fontSize: '1.25rem',
    lineHeight: 1.6,
    letterSpacing: '0.0075em',
  },
  body1: {
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '21px',
  },
  title1: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '26px',
    lineHeight: '32px',
  },
  title2: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '24px',
  },
  title3: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '20px',
  },
  headline: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '18px',
  },
  callout: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
  },
  button: {
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: 500,
  },
  subheadline: {
    fontWeight: 400,
    fontSize: '15px',
  },
  footnote: {
    fontWeight: 400,
    fontSize: '14px',
  },
  navigation: {
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '12px',
  },
  extraLargeNumber: {
    fontWeight: 300,
    fontSize: '80px',
    lineHeight: '92px',
  },
  label: {
    fontSize: '17px',
    fontWeight: 500,
  },
};
